var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperPlaneTilt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1406 2.24241L1.49513 5.52703C1.39716 5.55467 1.30996 5.61154 1.24518 5.69006C1.1804 5.76858 1.14112 5.865 1.13261 5.96644C1.1241 6.06788 1.14675 6.1695 1.19753 6.25771C1.24832 6.34593 1.32482 6.41655 1.41682 6.46013L6.76749 8.99466C6.87185 9.04409 6.95589 9.12812 7.00532 9.23248L9.53985 14.5832C9.58343 14.6752 9.65404 14.7517 9.74226 14.8024C9.83048 14.8532 9.9321 14.8759 10.0335 14.8674C10.135 14.8589 10.2314 14.8196 10.3099 14.7548C10.3884 14.69 10.4453 14.6028 10.4729 14.5048L13.7576 2.85936C13.7817 2.77382 13.7826 2.68339 13.7601 2.59739C13.7377 2.51139 13.6927 2.43293 13.6299 2.37008C13.567 2.30723 13.4886 2.26227 13.4026 2.23983C13.3166 2.21739 13.2262 2.21828 13.1406 2.24241Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92969 9.07061L9.75811 6.24219",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneTilt);
export default __webpack_public_path__ + "static/media/PaperPlaneTilt.d2e61e0ee5df4371d63ca6436193b269.svg";
export { ForwardRef as ReactComponent };